import { ref } from 'vue'
import type { App } from '../../backend/v2/src/app'
import { treaty } from '@elysiajs/eden'
import { nodeWithDefaults } from '../shared/default'
// import { edenFetch } from '@elysiajs/eden'

// const v2Fetch = edenFetch<App>('http://localhost:3000')
// const dummyApp = treaty<App>('', {
//   headers: {
//     'Content-Type': 'application/json',
//     'Authentication': 'Bearer <token>',
//   }
// })
const dummyTreaty = treaty<App>('', {})

export const openEdenUrl = (url: string) => {
  window.open(`${import.meta.env.VITE_V2URL}${url}`, '_blank')
}
const defaultQueryOptions = {
  enabled: true,
  authenticated: true,
  onQuery: () => {},
  onError: () => {},
}

export const useEdenQuery = <T>(
  callback: (
    app: typeof dummyTreaty,
  ) => Promise<T>,
  deps?: any[],
  pOption?: { authenticated?: boolean, prefix?: string, enabled?: boolean, onQuery?: (query: T) => void, onError?: (err: Error) => void },
) => {
  const { enabled, authenticated, onQuery, onError, prefix } = nodeWithDefaults(pOption || {}, defaultQueryOptions)
  const prefixRandom =
    (prefix || '') +
    Math.random().toString(36).substring(7) +
    Math.random().toString(36).substring(7)
  // const nuxtApp = useNuxtApp() config)
  const url = import.meta.env.VITE_V2URL
  // console.log('useEden', { url })
  const $acl = useAclStore()
  // console.log('useEden', { url, enabled, authenticated, isAuthenticated: !!$acl.currentUser?.id })
  const app = treaty<App>(url, {
    headers: [
      (path, options) => {
        return {
          'Content-Type': 'application/json',
          authorization: `Bearer ${$acl.currentUser?.accessToken}`,
        }
      }
    ],
  })
  const data = ref<T>()
  const error = ref()
  const loading = ref(false)
  const refreshIndex = ref(0)
  const executeIndex = ref(0)

  const execute = async (index?: number): Promise<T> => {
    if (typeof enabled === 'function' ? !enabled() : !enabled) {
      throw new Error('Not enabled')
    }
    // console.log('execute')
    if (!loading.value) {
      loading.value = true
      // throw new Error('Already running')
    }
    const res = await callback(app)
      .catch((err: any) => {
        error.value = err.message
        console.error('useEdenQuery: error:', err)
        onError(err)
        throw err
        // return undefined
      })
      .finally(() => {
        loading.value = false
      })
    if (index && index !== refreshIndex.value) {
      console.log('useEdenQuery skip', index, refreshIndex.value)
      return res
    }
    console.log('useEdenQuery', { prefixRandom, res })
    data.value = res

    onQuery(res)
    return res
  }

  watch(
    [() => $acl.currentUser?.id, enabled, ...deps],
    () => {
      // console.log('trpcAuthenticated?', $trpcAuthenticated.value, {prefixRandom, enabled})
      console.log('watch enabled?', enabled, prefixRandom, { requiredAuth: authenticated, authenticated: !!$acl.currentUser?.id })
      if (
        enabled &&
        (!authenticated || (authenticated && !!$acl.currentUser?.id))
      ) {
        // console.log(prefixRandom, 'running enabled', enabled, $trpcAuthenticated.value)
        // console.log(prefixRandom, 'running', enabled, $trpcAuthenticated.value)
        refreshIndex.value++
        const callExecute = (index: number) => {
          if (index !== refreshIndex.value) {
            // console.log('skip', index, refreshIndex.value)
            return
          }
          console.log(`${prefix}execute`, index)
          execute(index)
        }
        setTimeout(callExecute.bind(null, refreshIndex.value), 200)
      }
    },
    { immediate: true, deep: true },
  )

  return {
    data,
    error,
    loading,
    execute,
  }
}

export const useEden = async <T>(
  callback: (
    app: typeof dummyTreaty,
  ) => Promise<T>,
  pOption?: { authenticated?: boolean },
) => {
  const option = nodeWithDefaults(pOption || {}, { authenticated: false })
  // const nuxtApp = useNuxtApp()
  const url = import.meta.env.VITE_PUBLIC_V2_API_BASE
  // console.log('useEden', { url })
  // console.log('useEden', { url })
  const $acl = useAclStore()
  const app = treaty<App>(url, {
    headers: [
      (path, options) => {
        return {
          'Content-Type': 'application/json',
          authorization: `Bearer ${$acl.currentUser?.accessToken}`,
        }
      }
    ],
  })
  const res = await callback(app)
  // console.log('useEden', { res })
  if (res?.error?.value?.message) {
    throw new Error(res.error.value.message)
  }
  if (res?.error?.message) {
    throw new Error(res.error.message)
  }
  if (res?.error) {
    throw new Error(res.error)
  }
  return res
}
